import { useEffect, useState } from 'react';
import { transform } from '../../../helpers/transform';

const FormControlSwitch = (props) => {
    const { item, onChange, value } = props;
    const [response, setResponse] = useState(value || '');

    useEffect(() => {
        setResponse(value);
    }, [value]);

    const handleChange = (e) => {
        setResponse(e.target.checked);
        onChange(e.target.name, e.target.checked);
    };

    return (
        <div>
            <div
                className='form-check form-switch form-check-custom form-check-solid form__item'
                role='button'>
                <input
                    disabled={item.disabled}
                    checked={response && response !== 'false'}
                    className='form-check-input mr-5'
                    type='checkbox'
                    value={true}
                    name={item.name}
                    onChange={handleChange}
                />
                {!item.showLabel && (
                    <span>
                        <label className='form-check-label me-2'>
                            {item.label || transform('beautify', item.name)}
                        </label>
                        {item.tooltip && (
                            <i className='bi bi-info-circle-fill cursor-pointer'></i>
                        )}
                    </span>
                )}
            </div>
        </div>
    );
};

export default FormControlSwitch;
